export default "__VITE_ASSET__XfHsNyUd__"